import { CanopyProvider } from '@bloomfieldrobotics/canopy';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import LoadingPlantPage from '../pages/LoadingPlantPage';
import { BlockPointsMap } from './BlockPointsMap/BlockPointsMap';
import { useBlockDetails } from './useBlockDetails';

export const BlockDetailsPage = () => {
  const { blockId, scanId } = useParams<{ blockId: string; scanId: string }>();
  const { block, scan, loading } = useBlockDetails(blockId, scanId);

  return (
    <CanopyProvider>
      <Stack sx={{ flexGrow: 1, height: '100vh' }}>
        {block && scan && (
          <BlockPointsMap block={block} scan={scan} loading={loading} />
        )}
        {loading && <LoadingPlantPage />}
      </Stack>
    </CanopyProvider>
  );
};
